import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const Branch = () => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#F9FAFF] to-[#FFFFFF]">
      <div className="pt-[50px] pb-[80px] px-[200px] w-[1920px]">
        <PageTitle title="多分支、多场景智能组网" />
        <PageSubTitle title="设计架构灵活、可以快速部署企业专用全球网络，满足国内、国外各个场景需求" />
        <img src="/imgs/private/branch.png" className="w-full mt-[76px]" />
      </div>
    </div>
  );
};
